export default __webpack_public_path__ + "static/media/Vector.ce430c64.png";